import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import { useFormikContext } from 'formik'

import { useDateLocale, useTimeZone } from '../../../../../hooks'
import { DatePicker } from '../../../../DateTime'
import { FieldStackedLabel } from '../../../../Field'
import { FormikField } from '../../../../Formik'
import { Skeleton } from '../../../../Skeleton'
import Text from '../../../../Text'
import {
  CALENDAR_RELIEVE_DAY_FIELD_NAME_DATE,
  QA_NAME_CALENDAR_RELIEVE_DAY_TARGET_LOAD,
} from '../../CalendarRelieveDayModal.constants'
import {
  getCalendarRelieveDayTargetDate,
  getIsCalendarRelieveDayPending,
} from '../../CalendarRelieveDayModal.utils'

import { getCalendarRelieveDayTargetHint } from './TargetDayField.utils'

import * as styles from './TargetDayField.module.css'

function TargetDayField({ day, isLoading, nextFreeDay, targetLoad }) {
  const { t } = useTranslation()

  const locale = useDateLocale()
  const timezone = useTimeZone()

  const { values } = useFormikContext()

  const targetDate = getCalendarRelieveDayTargetDate({ timezone, values })

  const targetHint = getCalendarRelieveDayTargetHint({
    day,
    locale,
    nextFreeDay,
    t,
    targetDate,
    targetLoad,
  })

  return (
    <div className={styles.TargetDayField}>
      <FormikField
        Component={DatePicker}
        Field={FieldStackedLabel}
        disabled={isLoading}
        fieldComponentProps={{
          label: t('Calendar.RelieveDayTargetKey'),
          required: true,
        }}
        name={CALENDAR_RELIEVE_DAY_FIELD_NAME_DATE}
        placeholder={t('Common.DatePickerAddDateKey')}
      />
      {getIsCalendarRelieveDayPending({ isLoading, targetLoad }) ? (
        <Skeleton Element='span' className={styles.skeleton} />
      ) : targetHint ? (
        <Text
          className={classNames({ [styles.hintFull]: targetHint.isFull })}
          isSecondary={!targetHint.isFull}
          qaName={QA_NAME_CALENDAR_RELIEVE_DAY_TARGET_LOAD}
        >
          {targetHint.text}
        </Text>
      ) : null}
    </div>
  )
}

export default TargetDayField
